import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-resume-request-saved',
  templateUrl: './resume-request-saved.component.html',
  styleUrls: ['./resume-request-saved.component.scss']
})
export class ResumeRequestSavedComponent {

  @Input() numRadicado: any;
  @Output() closeResumeEvt = new EventEmitter<boolean>();



  emitEvtToCloseResume() {
    this.closeResumeEvt.emit(true);
  }

}
